import { useAuthStore } from '../store/authStore';
import { setAccessTokenLifetime } from './accessTokenLifetime';

export function applyAuthSession(
  accessToken: string,
  csrfToken: string,
  expiresInSeconds?: number | null
): void {
  const { setToken, setCsrfToken } = useAuthStore.getState();
  setToken(accessToken);
  setCsrfToken(csrfToken);
  setAccessTokenLifetime(expiresInSeconds);
}
